import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { printBatteries } from '../Api'

export default generateApiAction({
  baseType: Types.PRINT.BATTERIES,
  api: printBatteries,
  responseType: RESPONSETYPE.FILE
})



// WEBPACK FOOTER //
// ./src/actions/print/PrintBatteriesAction.js